var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "User",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16.479,
    viewBox: "0 0 15.5 16.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .activeUser {\r\n        fill: #1bc47d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-2",
    "data-name": "User",
    transform: "translate(-0.25 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "activeUser",
    d: "M3.75,0A3.75,3.75,0,1,0,7.5,3.75,3.75,3.75,0,0,0,3.75,0Z",
    transform: "translate(4.25 0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "activeUser",
    d: "M3.75,0A3.75,3.75,0,0,0,0,3.75V4.938A1.537,1.537,0,0,0,1.289,6.455a40.1,40.1,0,0,0,12.921,0A1.537,1.537,0,0,0,15.5,4.938V3.75A3.75,3.75,0,0,0,11.75,0h-.341a1.752,1.752,0,0,0-.543.086L10,.369a7.251,7.251,0,0,1-4.5,0L4.634.086A1.752,1.752,0,0,0,4.091,0Z",
    transform: "translate(0.25 10.25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUser);
export default __webpack_public_path__ + "static/media/active-user.a8e04dc3a2dc944afb1867a84db1c3ff.svg";
export { ForwardRef as ReactComponent };